<template>
  <div>
    <div>
      <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
        <div class="new-background-wrap">
          <div
            class="kachelimage header-image zoom-image"
            style="
              background: url('/static/img/default_header.png');
              background-position: top !important;
            "
          ></div>
          <!-- <img src="/static/img/video-main-banner.svg" /> -->
          <div class="headline-wrap">
            <div class="headline">
              <div class="text-subtitle-2 text-md-h5" v-if="editMode">
                {{ $t("edit_category") }}
              </div>
              <div class="text-subtitle-2 text-md-h5" v-else>
                {{ $t("video_category_name") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb v-if="!editMode" />
    <Breadcrumb v-else :trainingNameEdit="videoCategoryNameEdit" />
    <div class="text-center">
      <v-dialog v-model="openDeleteDialog" width="500">
        <h4>{{ $t("delete_video_category") }}</h4>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            @click="openDeleteDialog = false"
            outlined
            depressed
            tile
            class="cancelBtn mr-2 mb-2"
          >
            {{ $t("cancel") }}</v-btn
          >
          <v-btn
            @click="deleteCategory()"
            outlined
            depressed
            tile
            class="savebutton mr-2 mb-2"
          >
            <img
              src="/static/img/popup-delete-icon.svg"
              class="popup-delete-icon"
            />
            {{ $t("delete") }}</v-btn
          >
        </v-card-actions>
      </v-dialog>
    </div>
    <div class="pt-8">
      <div class="row disablerow justify-content-between align-items-start">
        <!-- Tabs -->
        <v-tabs
          v-model="languageTab"
          align-with-title
          touchless
          scrollable
          show-arrows
          class="LanguageselectTabgroup pt-md-4 pt-lg-0 pl-md-8 p-0 col-md-12 col-xl-9"
        >
          <v-tabs-slider color="indigo"></v-tabs-slider>

          <v-tab
            v-for="(language, i) in languageTabsNew"
            :key="language + i"
            class="LanguageselectTab"
          >
            <v-tooltip bottom>
              <template v-slot:activator="{ on, attrs }">
                <div
                  v-bind="attrs"
                  v-on="on"
                  style="display: flex; align-items: center"
                >
                  <img
                    style="width: 26px; height: 17px; vertical-align: unset"
                    :src="'/files/flags/' + language.flag"
                  />
                  &nbsp;&nbsp;
                  <span class="langauge-text-slider">
                    {{
                      language.shortForm === "KK"
                        ? "KZ"
                        : language.shortForm === "ZH" ||
                          language.shortForm === "CN"
                        ? "CN"
                        : $t(language.shortForm)
                    }}
                  </span>
                </div>
              </template>
              <span>{{ $t(language.language) }}</span>
            </v-tooltip>
          </v-tab>
        </v-tabs>
        <div class="col-md-12 col-xl-9 innercreatetraining">
          <v-tabs-items v-model="languageTab" touchless>
            <v-tab-item
              v-for="(language, i) in languageTabsNew"
              :key="language + i"
            >
              <div class="row disablerow justify-content-between">
                <!-- Put Content here -->
                <div class="col-md-12 mt-2">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    :label="$t('enter_category_name') + '*'"
                    v-model="category.designations[language.shortForm]"
                  ></v-text-field>
                </div>
                <div class="col-md-12">
                  <v-text-field
                    hide-details="auto"
                    class="datainput justify-content-end align-self-center pb-1"
                    dense
                    outlined
                    type="number"
                    :min="1"
                    :label="$t('sort_number')"
                    v-model="category.sortNumber"
                  ></v-text-field>
                </div>
                <div class="col-md-12">
                  <v-checkbox
                    v-model="category.internalLearning"
                    class="no-margin-top"
                    :label="$t('INTERNALLEARNINGVIDEOACESS')"
                  ></v-checkbox>
                </div>
              </div>
            </v-tab-item>
            <div class="col-md-12 lastBtnSubmit widAuto">
              <v-btn
                v-if="!editMode"
                v-show="$rights.includes('CREATE_VIDEO_CATEGORY')"
                @click="saveCategory()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                v-else
                v-show="$rights.includes('UPDATE_VIDEO_CATEGORY')"
                @click="saveCategory()"
                outlined
                depressed
                tile
                class="savebutton mr-2 mb-2"
                >{{ $t("save") }}</v-btn
              >
              <v-btn
                @click="$routerBack()"
                outlined
                depressed
                tile
                class="cancelBtn mr-2 mb-2"
                >{{ $t("cancel") }}</v-btn
              >
              <v-btn
                v-show="editMode && $rights.includes('DELETE_VIDEO_CATEGORY')"
                @click="openDeleteDialog = true"
                outlined
                depressed
                tile
                class="deletebutton cancelBtn mr-2 mb-2"
              >
                <v-icon color="#444">mdi-delete</v-icon>
                {{ $t("delete") }}</v-btn
              >
            </div>
          </v-tabs-items>
        </div>
        <div class="col-xl-3 px-0 pl-8 pl-md-6 row pt-0 onlyContact">
          <div class="col-xl-12 right-side-block hide">
            <h4 class="text-uppercase">{{ $t("actions") }}</h4>
            <div class="right-side divider"></div>
            <div class="mt-6"></div>
            <v-btn
              v-show="editMode && $rights.includes('DELETE_VIDEO_CATEGORY')"
              @click="openDeleteDialog = true"
              outlined
              depressed
              tile
              class="deletebutton mr-2 mb-2"
            >
              <v-icon color="#444">mdi-delete</v-icon> {{ $t("delete") }}</v-btn
            >
            <v-btn
              @click="$routerBack()"
              outlined
              depressed
              tile
              class="backbutton mr-2 mb-2"
            >
              <v-icon>mdi-chevron-left</v-icon> {{ $t("back") }}</v-btn
            >
            <v-btn
              v-if="!editMode"
              v-show="$rights.includes('CREATE_VIDEO_CATEGORY')"
              @click="saveCategory()"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
            <v-btn
              v-if="editMode"
              v-show="$rights.includes('UPDATE_VIDEO_CATEGORY')"
              @click="saveCategory()"
              outlined
              depressed
              tile
              class="save mr-2 mb-2"
              >{{ $t("save") }}</v-btn
            >
          </div>
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Card from "./custom/Card.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    Card,
    Breadcrumb,
  },

  props: {
    // categoryId: Number,
  },

  data() {
    return {
      editMode: false,
      languageTab: null,

      openDeleteDialog: false,
      categoryId: null,
      category: {
        designations: {},
        internalLearning: false,
        sortNumber: null,
      },
      activator: null,
      attach: null,
      colors: ["green", "purple", "indigo", "cyan", "teal", "orange"],
      editing: null,
      editingIndex: -1,
      nonce: 1,
      menu: false,
      x: 0,
      search: null,
      y: 0,
      videoCategoryNameEdit: "",
    };
  },
  computed: {
    languageTabsNew() {
      return this.$root.languageTabsNew;
    },
  },
  mounted() {
    if (this.$route.query.categoryId) {
      this.editMode = true;
      this.categoryId = this.$route.query.categoryId;
      this.fetchCategoryNameByID(this.categoryId);
    }
    // fetchCountries();
  },

  methods: {
    edit(index, item) {
      if (!this.editing) {
        this.editing = item;
        this.editingIndex = index;
      } else {
        this.editing = null;
        this.editingIndex = -1;
      }
    },

    filter(item, queryText, itemText) {
      if (item.header) return false;

      const hasValue = (val) => (val != null ? val : "");

      const text = hasValue(itemText);
      const query = hasValue(queryText);

      return (
        text.toString().toLowerCase().indexOf(query.toString().toLowerCase()) >
        -1
      );
    },
    onError(err) {
      if (err.response != null && err.response.data != null) {
        this.$noty.error(err.response.data);
      } else {
        console.error(err);
      }
    },

    lowerCaseMapKeys(map) {
      for (var key in map) {
        if (map.hasOwnProperty(key)) {
          if (key == key.toUpperCase()) continue;
          map[key.toUpperCase()] = map[key];
          delete map[key];
        }
      }
    },
    fetchCountries() {
      var _this = this;
      this.$axios
        .get("/api/location/countries")
        .then(function (response) {
          const countriesFromServer = response.data;
          _this.countries = [];
          for (let i = 0; i < countriesFromServer.length; i++) {
            const country = countriesFromServer[i];
            _this.countries.push({
              text: _this.$t(country),
              value: country,
            });
          }
          _this.countries.sort((a, b) =>
            a.text > b.text ? 1 : b.text > a.text ? -1 : 0
          );
          _this.$forceUpdate();
        })
        .catch(this.onError);
    },

    fetchCategoryNameByID() {
      var _this = this;
      this.$axios
        .get("/api/video/categoryname/" + this.categoryId)
        .then(function (response) {
          _this.category = response.data;
          _this.category.designations = _this.category.designationMap;
          _this.lowerCaseMapKeys(_this.category.designations);
          _this.videoCategoryNameEdit =
            _this.category.designations[_this.$locale.toUpperCase()];
        })
        .catch(this.onError);
    },

    saveCategory() {
      var _this = this;
      var category = {};
      category = Object.assign(category, this.category);
      const languages = [
        "EN",
        "DE",
        "FR",
        "PL",
        "ES",
        "HU",
        "RU",
        "KK",
        "IT",
        "ZH",
      ];
      const allEmptyOrSpaces = languages.every((lang) =>
        this.$isStringEmptyOrNull(category.designations[lang])
      );
      if (allEmptyOrSpaces) {
        this.$noty.error(
          this.$t("empty_value", { name: this.$t("video_category") })
        );
        return;
      }
      this.$convertHtmlDescriptionText(category.designations);

      if (this.categoryId === null) {
        this.$axios
          .post("/api/video/savename", category)
          .then(function (response) {
            _this.$noty.success(
              _this.$t("save_videocategory_name", {
                name: response.data.designationUrl,
              })
            );
            _this.$routerBack();
          })
          .catch(this.onError);
      } else {
        this.$axios
          .put("/api/video/update/" + this.categoryId, this.category)
          .then(function (response) {
            _this.$noty.success(_this.$t("edit_videocategory_name"));
            _this.$routerBack();
          })
          .catch(this.onError);
      }
    },

    deleteCategory() {
      if (this.categoryId == null) {
        console.error("You are not editing an existing category.");
        return;
      }

      var _this = this;

      this.$axios
        .delete("/api/video/" + this.categoryId)
        .then(function (response) {
          _this.$noty.success(
            _this.$t("delete_videocategory_name", {
              name: _this.category.designationMap[_this.$locale],
            })
          );
          _this.$router.push("/uploadvideo");
        })
        .catch(this.onError);
    },

    onFinally() {
      showLoadingCircle(false);
    },
  },
};
</script>
